module.exports = __webpack_public_path__ + "assets/img/apple.546292b1.png";